const __WEBPACK_NAMESPACE_OBJECT__ = window["ng-select"]["ng-option-highlight"];